import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
import {
  Table,
  Space,
  Breadcrumb,
  Select,
  Input,
  Button,
  Row,
  Col,
  Modal,
} from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined, CheckCircleFilled } from "@ant-design/icons";
const { Option } = Select;
class ProcessList extends Component {
  constructor() {
    super();
  }
  state = {
    details: [],
    newdetails: [],
    data: [],
    isConfirmModalVisible: false,
    paramaterValue: "",
  };

  onChange = async (value) => {
    this.search(value);
  };
  componentDidMount() {
    const details = [];
    axios
      .get(`${getServerUrl()}/master/process`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        this.setState({ details });
      });
  }
  componentDidUpdate() {
    console.log("New Data");
  }
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  render() {
    const data = this.state.details;
    const dataDropDown = this.state.details;
    const dropDownOptions = dataDropDown.map((dataDrop) => {
      return (
        <Option value={dataDrop.process_id}>{dataDrop.process_name}</Option>
      );
    });
    const columns = [
      {
        title: "Process Name",
        dataIndex: "process_name",
        key: "process_name",
        width: "30%",
        ...this.getColumnSearchProps("process_name"),
      },
      {
        title: "Description",
        dataIndex: "process_description",
        key: "process_description",
        width: "20%",
        ...this.getColumnSearchProps("process_description"),
      },
      {
        title: "Action",
        dataIndex: "process_id",
        key: "process_id",
        render: (text, record) => (
          <Space size="middle">
            <NavLink to={"/edit-process/" + record.process_id}>
              View / Manage
            </NavLink>
          </Space>
        ),
      },
      {
        title: "Delete",
        dataIndex: "process_id",
        key: "process_id",
        render: (text, record) => (
          <Space size="middle">
            <Button
              onClick={() => {
                deleteProcess(record.process_id);
              }}
            >
              Delete Process
            </Button>
          </Space>
        ),
      },
    ];
    function onSearch(val) {
      console.log("search:", val);
    }
    const deleteProcess = (params) => {
      this.setState({
        paramaterValue: params,
        isConfirmModalVisible: true,
      });
    };

    const handleConfirmOk = () => {
      axios
        .post(
          `${getServerUrl()}/master/deleteprocess`,
          { id: this.state.paramaterValue },
          {
            headers: { "x-auth-token": localStorage.getItem("token") },
          }
        )
        .then((res) => {
          let responsevalue = Object.values(res.data.data);
          const details = responsevalue;
          window.location.reload();
        });
      this.setState({
        isConfirmModalVisible: false,
      });
    };
    const handleConfirmCancel = () => {
      this.setState({
        isConfirmModalVisible: false,
      });
    };
    return (
      <div>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Master Settings </Breadcrumb.Item>
          <Breadcrumb.Item>Process Settings</Breadcrumb.Item>
          <Breadcrumb.Item>Process List</Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <h2 className="titles">
            VIEW / MANAGE PROCESS <span>DATA</span>
          </h2>
          <Row></Row>
          <Space></Space>
          <br />
          <Table columns={columns} dataSource={data}></Table>
        </div>
        <Modal
          title="Please Confirm"
          visible={this.state.isConfirmModalVisible}
          onOk={handleConfirmOk}
          okText="Yes, Proceed"
          onCancel={handleConfirmCancel}
          cancelText="No, Go Back"
        >
          <Row>
            <Col span={24}>
              <p
                style={{
                  color: "#303030",
                  fontSize: "22px",
                  textAlign: "center",
                }}
              >
                <CheckCircleFilled
                  style={{ fontSize: "36px", color: "#bc0067" }}
                />
                <br></br>
                Are you sure want to proceed?
              </p>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

export default ProcessList;
